import React from "react";
import styled from "styled-components";
import {InformationCircleIcon } from "@heroicons/react/20/solid";


export const AideContent = styled.div`

svg.iconflex{
    margin-right:2rem;
    margin-left:2rem;
    color:${props => props.theme.colors.main};
}
.alert{
    background-color: #1af46c2b !important;
    border: 0;
}
li::marker {
    color: ${props => props.theme.colors.main};
}
`;



function AidePacs() {
    return (
        <AideContent>
            <p>
                <div className="">
                Lorsque deux partenaires souhaitent officialiser leur union, le PACS offre une alternative simple au mariage. Il est essentiel de bien comprendre les effets juridiques du PACS, notamment en matière de patrimoine, de protection mutuelle et de succession. En choisissant de signer leur PACS chez un notaire, les partenaires sécurisent leur engagement et peuvent personnaliser leur convention selon leurs besoins spécifiques.
                </div>

                <p className="text-base font-bold leading-7 text-gray-900 mt-3">3 choses à retenir :</p>
                <div className="rounded-md bg-gray-50 p-4">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <InformationCircleIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                        </div>
                        <div className="ml-3">
                            <dt className="text-base font-bold leading-7 text-gray-900">Un cadre légal<span className="text-indigo-800">pour organiser votre vie commune</span>.</dt>
                            <p className="mt-2 text-base leading-7 text-gray-600 mb-0">👉 La convention de PACS vous permet de choisir comment organiser vos biens et vos obligations : séparation des patrimoines, organisation des dépenses, protection du logement commun, etc.</p>
                        </div>
                    </div>
                </div>
                <div className="mt-3 rounded-md bg-gray-50 p-4">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <InformationCircleIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                        </div>
                        <div className="ml-3">
                            <dt className="text-base font-bold leading-7 text-gray-900"> Une séparation des biens par défaut.</dt>
                            <p className="mt-2 text-base leading-7 text-gray-600 mb-0">👉 Par défaut, le PACS implique une séparation de biens. Chacun reste propriétaire de ce qu’il acquiert, sauf stipulation contraire dans la convention.</p>
                        </div>
                    </div>
                </div>
                <div className="mt-3 rounded-md bg-gray-50 p-4">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <InformationCircleIcon aria-hidden="true" className="h-5 w-5 text-gray-400" />
                        </div>
                        <div className="ml-3">
                            <dt className="text-base font-bold leading-7 text-gray-900"> Un testament est vivement recommandé</dt>
                            <p className="mt-2 text-base leading-7 text-gray-600 mb-0">👉 Le PACS n’ouvre pas automatiquement de droits successoraux. Pour protéger votre partenaire en cas de décès, il est fortement conseillé de rédiger un testament chez le notaire.</p>
                        </div>
                    </div>
                </div>

                

                <div className="rounded-md bg-emerald-50 p-4 mt-10">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            👋
                        </div>
                        <div className="ml-3 flex-1 md:flex md:justify-between">
                            <p className="text-sm text-emerald-700 mb-0">Il vous manque une information ? N'hésitez pas à contacter votre conseiller Clotere.</p>

                        </div>
                    </div>
                </div>




            </p>
        </AideContent>
    );
}

export default AidePacs;